// components/TenantLanding/Login/RegisterForms/Location1.js
import React from "react";

const COUNTRY_OPTIONS = [
  { value: "US", label: "United States" },
  { value: "GB", label: "United Kingdom" },
  { value: "IN", label: "India" },
  { value: "AU", label: "Australia" },
  { value: "CA", label: "Canada" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "IT", label: "Italy" },
  { value: "JP", label: "Japan" },
  { value: "CN", label: "China" },
  { value: "BR", label: "Brazil" },
  { value: "AE", label: "UAE" },
  { value: "SA", label: "Saudi Arabia" }
];

const TIMEZONE_OPTIONS = [
  { value: "Asia/Kolkata", label: "Asia/Kolkata (UTC+5:30)" },
  { value: "Asia/Dubai", label: "Asia/Dubai (UTC+4)" },
  { value: "Asia/Riyadh", label: "Asia/Riyadh (UTC+3)" },
  { value: "Asia/Singapore", label: "Asia/Singapore (UTC+8)" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo (UTC+9)" },
  { value: "Australia/Sydney", label: "Australia/Sydney (UTC+10)" },
  { value: "Europe/London", label: "Europe/London (UTC+0)" },
  { value: "Europe/Paris", label: "Europe/Paris (UTC+1)" },
  { value: "America/New_York", label: "America/New_York (UTC-5)" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles (UTC-8)" },
  { value: "America/Chicago", label: "America/Chicago (UTC-6)" },
  { value: "America/Phoenix", label: "America/Phoenix (UTC-7)" },
  { value: "UTC", label: "UTC" },
];

const Location1 = ({ formData, errors, loading, handleChange, handleNext, handlePrevious }) => {
  return (
    <div className="register-stage1-section">
      <h3 className="register-stage1-section__title">
        <span className="register-stage1-section__icon">📍</span>
        Location
      </h3>
      <p className="register-stage1-section__subtitle">
        Mobilisation, timezone and legal context.
      </p>

      <div className="register-stage1-form__row">
        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Country of Residence <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="country_of_residence"
              className={`register-stage1-form__select ${errors.country_of_residence ? "register-stage1-form__select--error" : ""}`}
              value={formData.country_of_residence}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Select your country</option>
              {COUNTRY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.country_of_residence && (
              <span className="register-stage1-form__error-text">{errors.country_of_residence}</span>
            )}
            <small className="register-stage1-form__help-text">
              Do not infer nationality from residence.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              City <span className="register-stage1-form__required">*</span>
            </label>
            <input
              type="text"
              name="city"
              className={`register-stage1-form__input ${errors.city ? "register-stage1-form__input--error" : ""}`}
              value={formData.city}
              onChange={handleChange}
              placeholder="Mumbai"
              disabled={loading}
            />
            {errors.city && (
              <span className="register-stage1-form__error-text">{errors.city}</span>
            )}
          </div>
        </div>

        <div className="register-stage1-form__col-full">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Time Zone <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="time_zone"
              className={`register-stage1-form__select ${errors.time_zone ? "register-stage1-form__select--error" : ""}`}
              value={formData.time_zone}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Select time zone</option>
              {TIMEZONE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.time_zone && (
              <span className="register-stage1-form__error-text">{errors.time_zone}</span>
            )}
            <small className="register-stage1-form__help-text">
              Used for communication and availability. Auto-detected but you can manually correct.
            </small>
          </div>
        </div>
      </div>

      <div className="register-stage1-form__actions">
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--outline"
          onClick={handlePrevious}
          disabled={loading}
        >
          ← Back
        </button>
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--primary"
          onClick={handleNext}
          disabled={loading}
        >
          Continue →
        </button>
      </div>
    </div>
  );
};

export default Location1;